export default {
  sections: {
    title: {
      title: 'Order confirmed',
      description: 'Your gift card has been purchased successfully',
    },
    instructions: {
      title: 'Check your email',
      description:
        "We've sent your gift card details and receipt to your email address. The gift card code will arrive within 5-10 minutes.",
    },
    details: {
      total: 'Total',
      order_number: 'Order number',
    },
    footer: {
      help: 'Our tech partner Foodamigos helps us manage gift cards. If you do not receive the gift card or cannot find it, please contact them at {{email}}',
      questions: 'If you have general questions regarding redemption, contact us directly at {{email}}',
    },
  },
  buttons: {
    go_home: 'Return to Home',
    download_pdfs: 'Download gift card PDF',
  },
};
